import Vue from 'vue';
import VueResource from 'vue-resource';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';

Vue.use(VueResource);

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/Projetos/ProjetosTerminando', { params: parametros });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/projetos-termino/servico.js